<template>
  <div>
    <!-- status-bar -->
    <div class="status-bar">
      <div class="status-block">
        <div class="status">금융기관용 기술신용평가 지원시스템</div>
        <!-- 로그인시 -->
        <ul v-if="isLogin">
          <!-- 게시판관리자 로그인시 -->
          <li v-if="isAdmin">
            <a href="/board/note">[공지사항]</a>
          </li>
          <li v-if="isAdmin">
            <a href="/board/pds">[자료실]</a>
          </li>
          
          <li>
            <a href="#">
              <span class="glyphicon glyphicon-user"></span>
              <span v-if="isAdmin">게시판관리자 : </span>{{ getName }} ({{ getClpNm }})
            </a>
          </li>
          <li>
            <a @click="logout">
              <span class="glyphicon glyphicon-log-out"></span> Logout
            </a>
          </li>
          <li>
            <a href="javascript:crFavorite('${contextPath}$');">
              <span class="glyphicon glyphicon-star"></span> Favorite
            </a>
          </li>
        </ul>
        <ul v-else>
          <!-- 로그아웃시 -->
          <li>
            <a href="/login">
              <span class="glyphicon glyphicon-log-in"></span> Login
            </a>
          </li>
          <li>
            <a href="javascript:crFavorite('${contextPath}$');">
              <span class="glyphicon glyphicon-star"></span> Favorite
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- /status-bar -->

    <!-- gnb-wrap -->
    <div class="gnb-wrap">
      <div class="gnb-container">
        <div class="gnb-bi-wrap">
          <a href="/">
            <img src="@/assets/images/gotcb-ci.png" />
          </a>
        </div>
        <ul class="gnb-list-wrap">
          <li>
            <a href="/issued-history">발급이력조회</a>
          </li>
          <li class="gnb-block">
            <span></span>
          </li>
          <li>
            <a href="/assessment/req-new">평가신청</a>
          </li>
          <li class="gnb-block">
            <span></span>
          </li>
          <li>
            <a href="/request-history">진행내역</a>
          </li>
          <li class="gnb-block">
            <span></span>
          </li>
          <li class="dropdown">
            <a @click="dropdown('result')" class="dropdown-toggle" data-toggle="dropdown" href="#">
              결과조회
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu" id="dropdown-result">
              <li>
                <a href="/result-history">평가결과확인</a>
              </li>
              <li>
                <a href="/renewal-history">갱신일 도래대상 업체확인</a>
              </li>
            </ul>
          </li>
          <li class="gnb-block">
            <span></span>
          </li>
          <li class="dropdown">
            <a @click="dropdown('guide')" class="dropdown-toggle" data-toggle="dropdown" href="#">
              평가안내
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu" id="dropdown-guide">
              <li>
                <a href="/guide/service">서비스안내</a>
              </li>
              <li>
                <a href="/guide/document">제출서류</a>
              </li>
              <li>
                <a href="/guide/dnb">평가기관(DNB)소개</a>
              </li>
            </ul>
          </li>
          <li class="gnb-block">
            <span></span>
          </li>
          <li class="dropdown">
            <a @click="dropdown('cs')" class="dropdown-toggle" data-toggle="dropdown" href="#">
              고객센터
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu" id="dropdown-cs">
              <li>
                <a href="/board/note">공지사항</a>
              </li>
              <li>
                <a href="/cs/faq">FAQ</a>
              </li>
              <li>
                <a href="/board/pds">자료실</a>
              </li>
              <li>
                <a href="/cs/contactus">찾아오시는 길</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- /gnb-wrap -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {},
  data() {
    return {
      onResultDrop: false,
      onGuideDrop: false,
      onCsDrop: false,
    };
  },
  computed: {
    ...mapGetters("userStore", ["isLogin"]),
    ...mapGetters("userStore", ["isAdmin"]),
    ...mapGetters("userStore", ["getName"]),
    ...mapGetters("userStore", ["getClpNm"]),
    ...mapGetters("userStore", ["getAccessToken"]),
  },
  mounted() {},
  methods: {
    logout() {
      if (confirm('로그아웃 하시겠습니까?')) {
        this.$store.dispatch("userStore/LOGOUT");
        alert("로그아웃 되었습니다.");
        this.$router.push("/");
      }
    },
    dropdown(key) {
      const component1 = document.getElementById('dropdown-result');
      const component2 = document.getElementById('dropdown-guide');
      const component3 = document.getElementById('dropdown-cs');
      const target = document.getElementById('dropdown-' + key);
      const display = target.getAttribute('style');

      component1.setAttribute('style', 'display: none;');
      component2.setAttribute('style', 'display: none;');
      component3.setAttribute('style', 'display: none;');

      if (!display || display == 'display: none;') {
        target.setAttribute('style', 'display: block;');
      }
    }
  },
};
</script>

<style>
a {
  cursor: pointer;
}

.dropdown-on {
  display: block;
}

.dropdown-off {
  display: none;
}
</style>